import Footer from "../../../components/footer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { DestinationAccountControllerType } from "../useDestinationAccount";
import { Button, OptionTile } from "@manifesthhqinc/ui-library";
import { TileContainer } from "./styles";
import {
  HeadlineMedium,
  BodyLargeRegular,
  BodyMediumRegular,
  BodyLargeBold,
  ErrorText,
} from "../../../components/font";
import HeadingContainer from "../../../layout/heading-container";

const DestinationChoiceScreen = (props: DestinationAccountControllerType) => {
  const {
    selectedClientDestination,
    clientDestinationOptions,
    redirectToOptions,
    onClickSkip,
    confirmDestinationChoice,
    confirmClientDestinationSelection,
    destinationChoiceError,
  } = props;
  if (!clientDestinationOptions) {
    redirectToOptions();
    return <></>;
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name="destination-overview">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium>Transfer into your existing account?</HeadlineMedium>
            <BodyLargeRegular>
              Since your old account is already with {clientDestinationOptions[0].providerName}, a rollover to a{" "}
              {clientDestinationOptions[0].providerName} account is usually the easiest path.
            </BodyLargeRegular>
          </HeadingContainer>

          <TileContainer $flexDirection="column" $width="100%" $marginTop={"24px"}>
            {destinationChoiceError && <ErrorText $marginBottom={16}>{destinationChoiceError}</ErrorText>}
            {clientDestinationOptions.map((clientDestination) => (
              <OptionTile
                key={`${clientDestination.providerName}-${clientDestination.type}`}
                variant="radioButton"
                isHereIsWhyExpanded
                onChange={() => confirmDestinationChoice(clientDestination)}
                appearance="secondary"
                isSelected={
                  !selectedClientDestination
                    ? false
                    : selectedClientDestination?.planSponsor === clientDestination.planSponsor ||
                      selectedClientDestination?.traditionalIraAccountNumber === clientDestination.accountNumber
                }
              >
                <BodyLargeBold>{clientDestination.providerName}</BodyLargeBold>
                <BodyMediumRegular>{clientDestination.type}</BodyMediumRegular>
                <BodyMediumRegular>
                  {clientDestination.planSponsor || clientDestination.accountNumber?.slice(-4)}
                </BodyMediumRegular>
              </OptionTile>
            ))}
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="exploreOptions" onClick={onClickSkip} size="large" variant="secondary">
          Explore other options
        </Button>
        <Button name="continue" onClick={confirmClientDestinationSelection} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default DestinationChoiceScreen;
